import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { ksefApi, KSeFSubmissionStatus } from "./ksefApi";

export const useKsefSubmissions = (
  integrationId: number,
  skip: number = 0,
  take: number = 20,
  status?: KSeFSubmissionStatus,
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.KSEF_SUBMISSIONS(integrationId, skip, take, status),
    queryFn: () => ksefApi.fetchSubmissions(integrationId, skip, take, status),
    placeholderData: keepPreviousData,
    enabled: integrationId > 0,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.KSEF_SUBMISSIONS(integrationId, skip, take, status) });
  };

  return { invalidate, isLoading, isFetching, submissions: data?.data ?? [] };
};
